<script setup lang="ts">
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
} from '@wartek-id/belajar-id-components'
import { useVModel } from '@vueuse/core'

interface Props {
  modelValue?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'zendesk:open'): void
}>()

const isOpen = useVModel(props, 'modelValue', emit)
</script>

<template>
  <Modal v-slot="{ close }" v-model="isOpen" :width="380">
    <ModalHeader
      class="text-interactive-critical-default bg-white border-none"
      @close="close"
    >
      Data email belum terdaftar di Dapodik.
    </ModalHeader>
    <ModalBody class="pt-0 pb-5">
      <p class="font-semibold text-xl mb-5">
        Hubungi Operator Sekolah untuk :
      </p>
      <ol class="mb-4">
        <li>1. ⁠Reset password lewat Portal Admin</li>
        <li>2. ⁠Update data terkini di Dapodik </li>
      </ol>
      <p>
        Jika data di Dapodik sudah ter-update namun Anda masih berkendala, silakan hubungi Bantuan.
      </p>
    </ModalBody>
  </Modal>
</template>
